module.exports = __webpack_public_path__ + "static/media/band.fc36ff99.jpg";